import TagManager from 'react-gtm-module'

export const trackDownloadButtonClick = (fileName: string) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'internal_click',
      click_type: 'Document Download',
      click_subtype: fileName,
    },
  }
  TagManager.dataLayer(tagManagerArgs)
}
